/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { HiTrash } from 'react-icons/hi2' // Npm: React icons.
import {
  Button,
  Flex,
  Spinner,
  Text
} from '@chakra-ui/react' // Npm: Chakra UI components.


/*
 * OBJECTS
 */
const Index = ({ icon, subHeading, onConfirm, isLoading, onClose }) => (
  <>
    <Flex
      direction='row'
      align='center'
      justifyContent='start'
      p='12px'
      gap='22px'>
      <Button px='0' py='0' w='auto' h='auto' bg='none' _hover={{ 'bg': 'none' }} _focus={{ 'bg': 'none' }} color='red.400'>{icon ? icon : <HiTrash size={37} />}</Button>
      <Flex
        direction='column'
        align='left'
        justifyContent='left'>
        <Text
          color='rgba(43, 54, 116, 1)'
          fontStyle='DM Sans'
          fontWeight='500'
          fontSize='21px'
          lineHeight='32px'>
          Are you sure ?
        </Text>
        <Text
          color='rgba(43, 54, 116, 0.5)'
          fontStyle='DM Sans'
          fontWeight='500'
          fontSize='16px'
          lineHeight='24px'>
          {subHeading}
        </Text>
      </Flex>
    </Flex>
    <Flex flexDirection='row' align='center' gap='22px' mt='10px'>
      <Button
        flex='1'
        height='3rem'
        fontStyle='DM Sans'
        fontWeight='700'
        fontSize='16px'
        lineHeight='24px'
        color='rgba(255, 255, 255, 1)'
        bg='red.500'
        _hover={{ 'bg': 'red.500' }}
        _active={{ 'bg': 'red.500' }}
        onClick={onConfirm}>
        {isLoading ? <Spinner color='rgba(255, 255, 255, 1)' size='sm' ml='10px' /> : 'Yes'}
      </Button>
      <Button
        flex='1'
        height='3rem'
        fontStyle='DM Sans'
        fontWeight='700'
        fontSize='16px'
        lineHeight='24px'
        bg='rgba(117, 81, 255, 1)'
        color='rgba(255, 255, 255, 1)'
        _hover={{ 'bg': 'rgba(117, 81, 255, 1)' }}
        _active={{ 'bg': 'rgba(117, 81, 255, 1)' }}
        onClick={onClose}>
        No
      </Button>
    </Flex>
  </>
)


/*
 * PROPTYPES
 */
Index.propTypes = {
  'icon': PropTypes.any,
  'subHeading': PropTypes.string,
  'onConfirm': PropTypes.func,
  'isLoading': PropTypes.bool,
  'onClose': PropTypes.func
}
Index.defaultProps = {
  'subHeading': 'That you want to delete this.'
}


/*
 * EXPORT
 */
export default Index
